import type { AppProps } from 'next/app'
import { Provider } from 'react-redux'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import { CacheProvider, EmotionCache } from '@emotion/react'
import { SnackbarProvider } from 'notistack'
import Script from 'next/script'
import store from 'src/store/store'
import theme from 'src/styles/theme'
import createEmotionCache from 'src/styles/createEmotionCache'
import '../styles/globals.scss'
import Layout from '../components/layout/main';

const clientSideEmotionCache = createEmotionCache()

interface MyAppProps extends AppProps {
  emotionCache?: EmotionCache
}

export default function MyApp(props: MyAppProps) {
  const { Component, emotionCache = clientSideEmotionCache, pageProps } = props

  return (
    <CacheProvider value={emotionCache}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <SnackbarProvider
            maxSnack={1}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            autoHideDuration={3000}
          >
            <CssBaseline />
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </SnackbarProvider>
        </ThemeProvider>
      </Provider>

      {/* ✅ Load accessibility widget after interaction */}
      <Script
        src="/userway.js"
        strategy="lazyOnload"
        async
      />

      {/* ✅ Load Intercom only in production */}
      {process.env.NODE_ENV === 'production' && (
        <>
          <Script
            id="intercom-init"
            strategy="lazyOnload"
            dangerouslySetInnerHTML={{
              __html: `
                window.intercomSettings = {
                  api_base: "https://api-iam.intercom.io",
                  app_id: "w38ydzmb"
                };
              `,
            }}
          />
          <Script
            id="intercom-script"
            strategy="lazyOnload"
            src="https://widget.intercom.io/widget/w38ydzmb"
          />
        </>
      )}
    </CacheProvider>
  )
}
